export default __webpack_public_path__ + "static/media/Nav-Info.19285211.svg";